<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="gateways">
      <div slot="toolbar">
        <el-upload
            action=""
            multiple
            :http-request="submitUpload"
            :show-file-list="false"
            :disabled="disabled">
          <el-button :loading="importLoading" type="primary" plain>
            <i class="el-icon-download"/>
            导入
          </el-button>
        </el-upload>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="网关编号">
            <el-input v-model.trim="filter.gatewayNo" clearable/>
          </vm-search>
          <vm-search label="终端型号">
            <el-input v-model.trim="filter.model" clearable/>
          </vm-search>
          <vm-search label="物料号">
            <el-input v-model.trim="filter.materialNo" clearable/>
          </vm-search>
          <vm-search label="订单号">
            <el-input v-model.trim="filter.purchaseOrderNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="gatewayNo" align="center" label="网关编号"/>
      <el-table-column prop="model" align="center" label="终端型号"/>
      <el-table-column prop="materialNo" align="center" label="物料号"/>
      <el-table-column prop="purchaseOrderNo" align="center" label="订单号"/>
      <el-table-column prop="createdTime" align="center" label="创建时间"/>
      <el-table-column prop="creatorName" align="center" label="创建人"/>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          width="120px"
          fixed="right">
        <template slot-scope="scope">
          <!--          <el-button v-if="editAuth" type="info" @click="$refs.editBox.open(scope.row)">编辑</el-button>-->
          <el-button v-if="editAuth" type="danger" @click="oneDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CustomerBoxEdit from "@/views/information/CustomerBox/CustomerBoxEdit.vue";
  import loginUtil from "@/util/loginUtil";

  export default {
    name: "",
    components: {VmTable, VmSearch},
    data() {
      return {
        editAuth: this.$auth(453),
        uploadUrl:window.config.basicServerHttpUrl+"gateways/importFile",
        uploadHeaders: {"Authorization": loginUtil.getToken()},
        idList: "",
        importLoading: false,
        disabled: false,
        filter: {
          gatewayNo:"",
          model: "",
          materialNo: "",
          purchaseOrderNo: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      submitUpload(params) {
        this.importLoading = true;
        this.disabled = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("file", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "gateways/importFile", formData)
          .then((res) => {
            console.log(res);
            this.importLoading = false;
            this.disabled = false;
            this.$message.info(res);
            this.getList(1);
          })
          .catch(() => {
            this.importLoading = false;
            this.disabled = false;
            this.getList(1);
            // this.$message.error("上传失败");
          });
      },
      // 单项删除
      oneDelete(row) {
        this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .delete("basic", "gateways", row.pkid).then(() => {
              this.getList(-1);
              this.$message.success("删除成功");
            });
        });
      },
      //导入
      onExceed() {
        this.$message.error("一次只能导入一张表，请刷新后再导入");
      },
      handleSuccess() {
        this.importLoading = false;
        this.disabled = false;
        this.$message.success("成功导入新的数据");
        this.getList(1);
      },
      onProgress() {
        this.importLoading = true;
        this.disabled = true;
      },
      handlerError(err) {
        this.importLoading = false;
        this.disabled = false;
        err = JSON.parse(err.message);
        alert("导入失败\n" + err.message);
      },
    },
  };
</script>

<style scoped>

</style>
